/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerGetDownloadUrlQueryResponse, ComparisonsControllerGetDownloadUrlPathParams, ComparisonsControllerGetDownloadUrl400, ComparisonsControllerGetDownloadUrl401, ComparisonsControllerGetDownloadUrl403, ComparisonsControllerGetDownloadUrl404 } from "../../models/comparisonsController/ComparisonsControllerGetDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { comparisonsControllerGetDownloadUrl } from "../../clients/comparisonsService/comparisonsControllerGetDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const comparisonsControllerGetDownloadUrlQueryKey = (id: ComparisonsControllerGetDownloadUrlPathParams["id"]) => [{
  url: '/api/v1/comparisons/:id/download-url',
  params: {
    id: id
  }
}] as const;
export type ComparisonsControllerGetDownloadUrlQueryKey = ReturnType<typeof comparisonsControllerGetDownloadUrlQueryKey>;
export function comparisonsControllerGetDownloadUrlQueryOptions(id: ComparisonsControllerGetDownloadUrlPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = comparisonsControllerGetDownloadUrlQueryKey(id);
  return queryOptions<ComparisonsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ComparisonsControllerGetDownloadUrl400 | ComparisonsControllerGetDownloadUrl401 | ComparisonsControllerGetDownloadUrl403 | ComparisonsControllerGetDownloadUrl404>, ComparisonsControllerGetDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return comparisonsControllerGetDownloadUrl(id, config);
    }
  });
}

/**
 * @summary Get presigned download URL for comparison PDF
 * {@link /api/v1/comparisons/:id/download-url}
 */
export function useComparisonsControllerGetDownloadUrl<TData = ComparisonsControllerGetDownloadUrlQueryResponse, TQueryData = ComparisonsControllerGetDownloadUrlQueryResponse, TQueryKey extends QueryKey = ComparisonsControllerGetDownloadUrlQueryKey>(id: ComparisonsControllerGetDownloadUrlPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<ComparisonsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ComparisonsControllerGetDownloadUrl400 | ComparisonsControllerGetDownloadUrl401 | ComparisonsControllerGetDownloadUrl403 | ComparisonsControllerGetDownloadUrl404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? comparisonsControllerGetDownloadUrlQueryKey(id);
  const query = useQuery({
    ...comparisonsControllerGetDownloadUrlQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComparisonsControllerGetDownloadUrl400 | ComparisonsControllerGetDownloadUrl401 | ComparisonsControllerGetDownloadUrl403 | ComparisonsControllerGetDownloadUrl404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}